export const CONTENT_ID = {
  CUISINE_FILTERS: 'shef-navigation-cuisine-content',
  DATE_PICKER: 'shef-navigation-date-picker-content',
  DIETARY_FILTERS: 'shef-navigation-dietary-filters-content',
  PROTEIN_FILTERS: 'shef-navigation-protein-filters-content',
  FILTER_BAR_INLINE: 'shef-navigation-filter-bar-inline-content',
  FILTER_BAR: 'shef-navigation-filter-bar-content',
  MENU_BAR: 'shef-navigation-menu-bar',
  MORE_FILTERS: 'shef-navigation-more-filters-content',
  NAVIGATION: 'shef-navigation-content',
  PROMO_SPACER: 'shef-navigation-promo',
  SEARCH: 'shef-search-content',
  SUB_CUISINE_FILTERS: 'shef-navigation-sub-cuisine-content',
};
